// Helpers para gerar variações (degradê) a partir da cor principal da empresa

function normalizarHex(hex: string): string {
  let cor = (hex || "").replace("#", "").trim();
  if (cor.length === 3) {
    cor = cor
      .split("")
      .map((c) => c + c)
      .join("");
  }
  return /^[0-9a-fA-F]{6}$/.test(cor) ? cor : "006400";
}

function hexParaRgb(hex: string) {
  const cor = normalizarHex(hex);
  return {
    r: parseInt(cor.substring(0, 2), 16),
    g: parseInt(cor.substring(2, 4), 16),
    b: parseInt(cor.substring(4, 6), 16),
  };
}

// fator > 0 clareia (em direção ao branco), fator < 0 escurece (em direção ao preto)
export function ajustarCor(hex: string, fator: number): string {
  const { r, g, b } = hexParaRgb(hex);
  const alvo = fator > 0 ? 255 : 0;
  const f = Math.min(Math.abs(fator), 1);
  const mix = (c: number) => Math.round(c + (alvo - c) * f);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
}

export function corComAlpha(hex: string, alpha: number): string {
  const { r, g, b } = hexParaRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Cor de texto legível sobre a cor informada
export function corTextoSobre(hex: string): string {
  const { r, g, b } = hexParaRgb(hex);
  const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminancia > 0.65 ? "#1b1b1b" : "#ffffff";
}

export function gradienteHero(hex: string): string {
  return [
    "radial-gradient(circle at 85% 8%, rgba(255,255,255,0.14), rgba(255,255,255,0) 45%)",
    `linear-gradient(165deg, ${ajustarCor(hex, 0.08)} 0%, ${ajustarCor(hex, -0.15)} 50%, ${ajustarCor(hex, -0.45)} 100%)`,
  ].join(", ");
}

export function gradienteCard(hex: string): string {
  return `linear-gradient(145deg, ${ajustarCor(hex, 0.05)} 0%, ${ajustarCor(hex, -0.25)} 55%, ${ajustarCor(hex, -0.5)} 100%)`;
}
